import type { AutoJerryReviewsData } from './parseAutoJerryHtml';

export const isValidAutoJerryReviewsData = (data: unknown): data is AutoJerryReviewsData => {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const { rating, reviewCount } = data as AutoJerryReviewsData;

  return (
    typeof rating === 'number' &&
    Number.isFinite(rating) &&
    rating >= 1 &&
    rating <= 5 &&
    typeof reviewCount === 'number' &&
    Number.isFinite(reviewCount) &&
    Number.isInteger(reviewCount) &&
    reviewCount >= 0
  );
};
